// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__n8Duz","topBottomGutter":"Layout_topBottomGutter__10QrO"};